<aside 
    class="nano affix sidebar_left_position edit-route-left" 
    ng-class="tab == 0 ? 'show-mobile-sidebar' : 'hide-mobile-sidebar'">
    <div class="panel-body p20 routing-list">
        <div class="table-responsive">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-left float-right"></th>
                        <th class="text-center">Stops</th>
                        <th class="text-center">Time</th>
                        <th class="text-center">Distance</th>
                        <th class="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="route in data.routes"
                        ng-class="{'checked': selectedItems.indexOf(item.id) > -1}">

                        <td scope="clickable-row text-left" ng-click="openRoute(route)" >
                            <div style="display: flex;align-items: center;justify-content: flex-start;">
                                <svg widtd="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d)">
                                    <circle cx="15" cy="12" r="9" fill="{{route.color}}" stroke="white" stroke-width="2"/>
                                    </g>
                                    <defs>
                                    <filter id="filter0_d" x="0" y="0" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dy="3"/>
                                    <feGaussianBlur stdDeviation="2.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                                <div class="pl20">
                                    <span>{{ route.unique }}</span>
                                    <br>
                                    <strong>{{ route.worker ? route.worker.full_name : 'Not Assigned'}}</strong>
                                </div>
                            </div>
                        </td>
                        <td class="clickable-row" ng-click="openRoute(route)">{{ route.order_count }}</td>
                        <td class="clickable-row text-center" ng-click="openRoute(item)">
                            {{ humanizeDuration(route.total_time) }}
                        </td>
                        <td class="clickable-row text-center" ng-click="openRoute(item)">
                            {{ route.total_mile.toFixed(2) }} Mile
                        </td>
                        <td>
                            <!-- <a href="#" 
                                class="btn btn-warning btn-small" 
                                data-dismiss="modal" 
                                data-toggle="modal" 
                                data-target="#assignToWorkerRoute"
                                ng-click="openRoute(route)">
                                <span ng-if="!route.worker">Assign</span>
                                <span ng-if="route.worker">Change</span>
                            </a> -->
                            <a href="#" 
                                class="btn btn-danger btn-rounded mt5" 
                                ng-click="delete(route)">
                                <span>Delete</span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div> 
</aside>

